import { IMaskInput } from 'react-imask';
import { forwardRef, useCallback } from 'react';
import { TextField, type TextFieldProps } from '@mui/material';
import type { InputBaseComponentProps } from '@mui/material/InputBase';

type CustomImaskInputProps = InputBaseComponentProps & {
  onChange: (event: { target: { name: string; value: string } }) => void;
  mask: string;
  name: string;
};

const CustomImaskInput = forwardRef<HTMLInputElement, CustomImaskInputProps>(function TextMaskCustom(props, ref) {
  const { onChange, mask, ...other } = props;

  const handleAccept = useCallback(
    (value: string) => {
      onChange({ target: { name: props.name, value } });
    },
    [onChange, props.name]
  );

  return (
    <IMaskInput
      {...other}
      mask={mask}
      definitions={{ '#': /[0-9]/ }}
      inputRef={ref}
      onAccept={handleAccept}
      overwrite
    />
  );
});

type Props = TextFieldProps & { mask: string };

export const MaskedTextField = ({ mask, slotProps, ...props }: Props) => {
  return (
    <TextField
      {...props}
      slotProps={{
        input: {
          ...(slotProps?.input ?? {}),
          inputComponent: CustomImaskInput,
          inputProps: { ...props.inputProps, mask },
        },
      }}
    />
  );
};
